import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Editor } from "../controls/Editor";
import { useDispatch } from "react-redux";
import { devActions } from "../../../redux/actions";
import { emptyObject } from "../../../redux/utils";
import { PanelSpinner } from "./PanelSpinner";

export const FileEditorPrimitiva = ({tab, index}) => {

  const [ loaded, setLoaded ] = useState(false);
  const dispath = useDispatch();

  const formik = useFormik({
    initialValues: tab?.data?.data?.value || emptyObject,
    onSubmit: (data) => {},
  })
  
  useEffect(() => {
    const values = {
      templateBodyJson: tab?.data?.data?.value?.templateBodyJson || tab?.data?.metadata?.item?.templateBodyJson,
      templateBodyJsonOutput: tab?.data?.data?.value?.templateBodyJsonOutput || tab?.data?.metadata?.item?.templateBodyJsonOutput
    };
    console.log("tab.data.data.value change effect", { values, loaded });
    if(!loaded && values.templateBodyJson !== undefined && values.templateBodyJsonOutput !== undefined){
      console.log("tab.data.data.value change effect", "entra");
      formik.setValues(values);
      setTimeout(() => {
        setLoaded(true);
      }, 100);
    }
  }, [loaded, tab?.data?.data?.value, tab?.data?.metadata?.item])

  const handleCodeChangeInput = (code) => {
    console.log("handleCodeChangeInput", {code, loaded, index})
    if(loaded && code !== formik.values.templateBodyJson){
      formik.setFieldValue("templateBodyJson", code);
      dispath(devActions.setChangedTab(index, true));
      dispath(devActions.updateTabPrimitiva(index, {templateBodyJson: code, templateBodyJsonOutput: formik.values.templateBodyJsonOutput}));
    }
  }

  const handleCodeChangeOutput = (code) => {
    console.log("handleCodeChangeOutput", {code, loaded, index})
    if(loaded && code !== formik.values.templateBodyJsonOutput){
      formik.setFieldValue("templateBodyJsonOutput", code);
      dispath(devActions.setChangedTab(index, true));
      dispath(devActions.updateTabPrimitiva(index, {templateBodyJson: formik.values.templateBodyJson, templateBodyJsonOutput: code}));
    }
  }

  return (
    <>
      {loaded &&
        <div style={{height: "100%", backgroundColor: "#272822", position: "relative", display: "flex", flexDirection: "row"}}>
          <div style={{flex: 1, display: "flex", flexDirection: "column"}}>
            <div className="dev-header">Objeto de Entrada</div>
            <Editor
              mode={"json"}
              autoFocus={true}
              value={tab.data.metadata.item.templateBodyJson}
              onValueChange={handleCodeChangeInput}
              fontSize={16}
              maxHeight = "100%"
              showToolbar={false}
              editorStyle={{height: "100%", backgroundColor: "#272822", position: "relative"}}
            />
          </div>
          <div style={{flex: 1, display: "flex", flexDirection: "column"}}>
            <div className="dev-header">Objeto de Salida</div>
            <Editor
              mode={"json"}
              autoFocus={true}
              value={tab.data.metadata.item.templateBodyJsonOutput}
              onValueChange={handleCodeChangeOutput}
              fontSize={16}
              maxHeight = "100%"
              showToolbar={false}
              editorStyle={{height: "100%", backgroundColor: "#272822", position: "relative"}}
            />
          </div>
        </div>
      }
      {!loaded && 
        <PanelSpinner />
      }
    </>
  )

}